import { frontendURL } from 'dashboard/helper/URLHelper.js';
import Index from './Index.vue';

const meta = {
  permissions: ['administrator'],
};

const routes = [
  {
    path: frontendURL('accounts/:accountId/campaign'),
    name: 'electoral_campaign_overview',
    meta,
    component: Index,
  },
];

export default { routes };
